import contain from './contain.js';
import scaleDown from './utils/scaleDown.js';

/**
 * Child is sized as `none` or `contain`,
 * whichever would result in a smaller size.
 * @param {object} parent
 * @param {object} child
 * @returns {object}
 */
const containScaleDown = (parent, child) => {
  return scaleDown(parent, child, contain);
};

export default containScaleDown;
